import type { AchievementsType } from '@/types';
import { Carousel } from '@mantine/carousel';
import { AspectRatio, Card, Image, Stack, Text } from '@mantine/core';
export const VipAchievementItem: React.FC<AchievementsType> = ({
  id,
  imgCard,
  title
}) => {
  return <Carousel.Slide>
      <Card bg="var(--striped-bg-color)" w={{
      base: 116,
      sm: 155,
      md: 140
    }} radius={5} p="md">
        <Stack align="center" gap={10}>
          <AspectRatio ratio={1 / 1}>
            <Image src={imgCard} alt={`achievement-${id}`} w={{
            base: 48,
            sm: 64
          }} h={{
            base: 48,
            sm: 64
          }} />
          </AspectRatio>

          <Text fz={{
          base: 10,
          sm: 12
        }} fw={700} c="var(--text-dark)" tt="uppercase" ta="center" style={{
          textWrap: 'nowrap'
        }}>
            {title}
          </Text>
        </Stack>
      </Card>
    </Carousel.Slide>;
};